export class CarrierDocumentVersion {
    documentVersionId: string;
    documentId: string;
    title: string;
    pageCount: number;
    archive: boolean;
    isLinked: boolean;
}